import { request } from "@/interface/helper";

const str = "communityPost";

export const communityPost = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/community/post/list" }),
    add: data => request({ data, method: "post", url: "/community/post/add" }),
    detail: data => request({ data, method: "post", url: "/community/post/detail" }),
    edit: data => request({ data, method: "post", url: "/community/post/modify" })
  }
};
